import { ACHIEVEMENTS_LIST } from '../constants/achievements';
import { SPECIAL_FISH_TYPES } from '../constants/specialFish';
import { showNotification } from '../components/ui/NotificationContainer';

export const checkAchievements = (state, dispatch) => {
  ACHIEVEMENTS_LIST.forEach(achievement => {
    if (!state.unlockedAchievements.includes(achievement.id) && achievement.requirement(state)) {
      dispatch({ type: 'UNLOCK_ACHIEVEMENT', payload: achievement });
      showNotification(`解鎖成就: ${achievement.title}`, 'success');

      // 如果成就解鎖特殊木魚,顯示額外通知並標記木魚為未查看
      if (achievement.unlocksFish) {
        setTimeout(() => {
          showNotification(`解鎖特殊木魚: ${achievement.unlocksFish}`, 'success');
          
          // 找到對應的木魚ID並標記為未查看
          const fish = SPECIAL_FISH_TYPES.find(f => f.name === achievement.unlocksFish);
          if (fish) {
            dispatch({ type: 'UNLOCK_FISH', payload: fish.id });
          }
        }, 500);
      }
    }
  });
};

export const getAchievementProgress = (state) => {
  const unlockedCount = state.unlockedAchievements.length;
  const totalCount = ACHIEVEMENTS_LIST.length;
  const percentage = Math.round((unlockedCount / totalCount) * 100);

  return {
    unlocked: unlockedCount,
    total: totalCount,
    percentage
  };
};

export const getAchievementsByCategory = (category) => {
  if (category === 'all') {
    return ACHIEVEMENTS_LIST;
  }
  return ACHIEVEMENTS_LIST.filter(achievement => achievement.type === category);
};